import { render, staticRenderFns } from "./skinnyPagination.vue?vue&type=template&id=4808bc9e&scoped=true"
import script from "./skinnyPagination.vue?vue&type=script&lang=js"
export * from "./skinnyPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4808bc9e",
  null
  
)

export default component.exports